import React from 'react';
import { useSearchParams } from 'react-router-dom';

const AppointmentDummyPayment = () => {
  const [searchParams] = useSearchParams();
  const appointmentid = searchParams.get('appointmentid');

  const handlePayment = (status: 'success' | 'fail') => {
    const tid = (10 * Math.random()).toFixed(4);
    // Redirecting to the update route with the query params provided
    window.location.href = `/paymentupdate?paymentstatus=${status}&transactionid=${tid}&appointmentid=${appointmentid}`;
  };

  return (
    <div className="content-area empty-state">
      <h1 className="dash-title">Secure Payment Gateway</h1>
      <p className="card-text">Appointment ID: {appointmentid}</p>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
        <button className="btn-blue" onClick={() => handlePayment('success')}>Pay Now Success</button>
        <button className="btn-blue" style={{ background: '#c53030' }} onClick={() => handlePayment('fail')}>Pay Now Fail</button>
      </div>
    </div>
  );
};

export default AppointmentDummyPayment;